import {Text, View} from '@/components/react-native';
import classNames from 'classnames';

const buttonClass =
  'flex-row items-center justify-center py-[12px] rounded-[8px] flex-1 border-[2px] bg-[#35B65C4D]';

const NoteApprove = ({
  status,
  setStatus,
  content,
  setContent
}: {
  status: 'pending' | 'approved' | 'rejected';
  setStatus: (status: 'pending' | 'approved' | 'rejected') => void;
  content: string;
  setContent: (content: string) => void;
}) => {
  return (
    <View className="flex-1">
      <View className="px-[16px] py-[18px] uppercase">
        <Text
          fontFamily="GeistMono"
          className="text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px] uppercase"
        >
          review action
        </Text>
      </View>
      <div className="w-full flex-row items-center justify-between gap-[6px] px-[16px]">
        <button
          onClick={() => setStatus('approved')}
          className={classNames(buttonClass, {
            'border-[#35B65C]': status === 'approved',
            'border-transparent': status !== 'approved'
          })}
        >
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.4974 9.9974L8.9974 12.4974L13.9974 7.4974M18.5807 9.9974C18.5807 14.5998 14.8498 18.3307 10.2474 18.3307C5.64502 18.3307 1.91406 14.5998 1.91406 9.9974C1.91406 5.39502 5.64502 1.66406 10.2474 1.66406C14.8498 1.66406 18.5807 5.39502 18.5807 9.9974Z"
              stroke="#35B65C"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <Text
            fontFamily="Geist"
            className="ml-[4px] text-[#35B65C] text-[16px] font-[500] tracking-[-0.32px]"
          >
            Accept
          </Text>
        </button>
        <button
          onClick={() => setStatus('rejected')}
          className={classNames(buttonClass, {
            'border-[#E94860]': status === 'rejected',
            'border-transparent': status !== 'rejected'
          })}
        >
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.2474 7.4974L8.2474 12.4974M8.2474 7.4974L13.2474 12.4974M19.0807 9.9974C19.0807 14.5998 15.3498 18.3307 10.7474 18.3307C6.14502 18.3307 2.41406 14.5998 2.41406 9.9974C2.41406 5.39502 6.14502 1.66406 10.7474 1.66406C15.3498 1.66406 19.0807 5.39502 19.0807 9.9974Z"
              stroke="#E94860"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <Text
            fontFamily="Geist"
            className="ml-[4px] text-[#E94860] text-[16px] font-[500] tracking-[-0.32px]"
          >
            Reject
          </Text>
        </button>
      </div>
      {status === 'approved' && (
        <>
          <View className="px-[16px] py-[18px] uppercase mt-[24px]">
            <Text
              fontFamily="GeistMono"
              className="text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px] uppercase"
            >
              EDIT NOTE CONTENT (OPTIONAL)
            </Text>
          </View>
          <View className="px-[16px] w-full">
            <textarea
              className="bg-[#010009] px-[16px] py-[12px] rounded-[6px] w-full min-h-[200px] text-white"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            >
              {content}
            </textarea>
          </View>
        </>
      )}
    </View>
  );
};

export default NoteApprove;
